import { UserRole } from "../types/types";

export const isAdminRole = (role?: UserRole | null) => role === "ADMIN";

export const canManageContent = (role?: UserRole | null) =>
  role === "ADMIN" || role === "CREATOR";
